import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import Sidebar from "./Sidebar";

export default function Layout({ onLogout }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="app-layout">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} onLogout={onLogout} />
      <main
        className={`flex-1 transition-all duration-200 ${
          collapsed ? "ml-16" : "ml-[260px]"
        }`}
      >
        <div className="max-w-[1600px] mx-auto px-6 py-6">
          <Outlet />
        </div>
      </main>
      <footer
        className={`border-t border-slate-200 bg-white transition-all duration-200 ${
          collapsed ? "ml-16" : "ml-[260px]"
        }`}
        data-testid="app-footer"
      >
        <div className="max-w-[1600px] mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <div className="flex flex-col">
              <span className="text-sm font-bold text-[#003057] tracking-tight">Testflow</span>
              <span className="text-[8px] font-semibold tracking-[0.2em] uppercase text-slate-400">
                POWERED BY FLOWINGO
              </span>
            </div>
            <span className="text-xs text-slate-400">Automotive Test Reporting Platform</span>
          </div>
          <div className="flex items-center gap-4">
          </div>
        </div>
      </footer>
    </div>
  );
}
